<template>
  <div class="home-ads">
    <div class="single-ad" v-if="showSingle">
      <a :href="singleAd.turnUrl || 'javascript:void(0)'" :target="singleAd.turnUrl ? '_blank' : '_self'">
        <img :src="singleAd.imageUrl" />
        <span v-if="singleAd.isShowTag === 1" class="ad-tag">广告</span>
      </a>
    </div>
    <div class="double-ad" v-if="showDouble">
      <a v-for="(item, idx) in doubleAds" :key="idx" :href="item.turnUrl || 'javascript:void(0)'" :target="item.turnUrl ? '_blank' : '_self'">
        <img :src="item.imageUrl" />
        <span v-if="item.isShowTag === 1" class="ad-tag">广告</span>
      </a>
    </div>
    <div class="triple-ad" v-if="showTriple">
      <a v-for="(item, idx) in tripleAds" :key="'triple-' + idx" :href="item.turnUrl || 'javascript:void(0)'" :target="item.turnUrl ? '_blank' : '_self'">
        <img :src="item.imageUrl" />
        <span v-if="item.isShowTag === 1" class="ad-tag">广告</span>
      </a>
    </div>
  </div>
</template>

<script>
import { fetchAdDetails, resolveAdImage } from '../../../api'

export default {
  name: 'HomeAds',
  props: {
    positionKey: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'single',
      validator: val => ['single', 'double', 'triple'].includes(val)
    },
    single: {
      type: String,
      default: ''
    },
    double: {
      type: Array,
      default: () => []
    },
    triple: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ads: []
    }
  },
  computed: {
    isStatic() {
      return !this.positionKey
    },
    singleAd() {
      if (this.isStatic) {
        return { imageUrl: this.single, turnUrl: '#' }
      }
      return this.ads[0] || {}
    },
    doubleAds() {
      if (this.isStatic) {
        return this.double.map(url => ({ imageUrl: url, turnUrl: '#' }))
      }
      return this.ads.slice(0, 2)
    },
    tripleAds() {
      if (this.isStatic) {
        return this.triple.map(url => ({ imageUrl: url, turnUrl: '#' }))
      }
      return this.ads.slice(0, 3)
    },
    showSingle() {
      return this.type === 'single' && this.singleAd.imageUrl
    },
    showDouble() {
      return this.type === 'double' && this.doubleAds.length
    },
    showTriple() {
      return this.type === 'triple' && this.tripleAds.length
    }
  },
  created() {
    if (this.positionKey) {
      this.loadAds()
    }
  },
  methods: {
    async loadAds() {
      const list = await fetchAdDetails(this.positionKey)
      this.ads = (list || []).map(item => ({
        ...item,
        imageUrl: resolveAdImage(item.imageUrl)
      }))
    }
  }
}
</script>

<style scoped>
.home-ads {
  width: 1400px;
  margin: 0 auto;
  margin-top: 30px;
}
.single-ad a,
.double-ad a,
.triple-ad a {
  display: block;
  text-decoration: none;
  position: relative;
}

.ad-tag {
  position: absolute;
  top: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  font-size: 12px;
  padding: 2px 8px;
  border-radius: 0 4px 0 4px;
  line-height: 1.5;
}
.single-ad img {
  display: block;
  width: 1400px;
  height: 120px;
  object-fit: cover;
  border-radius: 4px;
}
.double-ad,
.triple-ad {
  display: flex;
  gap: 28px;
  justify-content: center;
}
.double-ad img,
.triple-ad img {
  display: block;
  width: 447px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
}
</style>
